const config =  {
    aesSecret: process.env.REACT_APP_AUTO_REDEEM_SECRET_KEY,
    rewardsByLandingUrl: process.env.REACT_APP_REWARDSBY_LANDING_URL,
    captchaSiteKey: process.env.REACT_APP_CAPTCHA_SITE_KEY
}

export default config;
